import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ITrainingRecordSummary } from '../../../message-models/training-record-summary.interface';
import { IObservation } from '../../../message-models/observation.interface';
import { Router } from '@angular/router';
import { ITrainingRecord } from '../../../message-models/training-record.interface';
import { IAllowedOperations } from "../../../users/models/userInfo.interface";
import { DatePipe } from '@angular/common';
import { ExportExcelService } from 'src/app/common/services/export-excel.service';
import { EcaConfirmProcessService } from "../../../shared/services/eca-confirm-process.service";
import { EcaConfirmDeleteModalOptions } from "../../../shared/models/confirm-delete-modal-options.class";
import { TrainingRecordsService } from "../../../training-records/services/training-records.service";
import { MenuItem } from 'primeng/api';
import { ErrorHandlingService } from '../../../services/error-handling.service';
import { ITrainingMatrix } from '../../../message-models/training-matrix.interface';

@Component({
  selector: 'app-company-operative-training-records',
  templateUrl: './company-operative-training-records.component.html',
  styleUrls: ['./company-operative-training-records.component.scss']
})
export class CompanyOperativeTrainingRecordsComponent implements OnInit {
  isOnMobile = false;
  @Input() showHeaderText = true;
  @Input() trainingRecords: Array<ITrainingRecordSummary> = new Array<ITrainingRecordSummary>();
  @Input() allowedOperations: IAllowedOperations;
  @Input() companyId: string;
  @Output() refreshListRequested: EventEmitter<any> = new EventEmitter<any>();
  @Output() trainingRecordId: EventEmitter<string> = new EventEmitter<string>();
  columns: any[];
  exportColumns: any[];
  matrixColumns: any[];
  companyOperativesTraingRecordsToExport: any[] = [];
  rowMenuItems: MenuItem[];

  constructor(private router: Router, private confirmProcessService: EcaConfirmProcessService, private datePipe: DatePipe,
    private trainingRecordsService: TrainingRecordsService,
    private exportExcelService: ExportExcelService,
    private errorHandlingService: ErrorHandlingService,
  ) { }

  ngOnInit(): void {
    this.isOnMobile = window.outerWidth <= 480;
    this.columns = [
      { field: 'operativeFirstName', header: 'Operative First Name', type: 'text' },
      { field: 'operativeLastName', header: 'Operative Last Name', type: 'text' },
      { field: 'achievedOn', header: 'Achieved On', type: 'date' },
      { field: 'validTo', header: 'Valid To', type: 'date' },
      { field: 'trainingTypeName', header: 'Training Course', type: 'text' },
      { field: 'trainingExtraDescription', header: 'Description', type: 'html' },
      { field: 'categoryName', header: 'Category Name', type: 'text' },
      { field: 'totalObservations', header: 'Observations', type: 'text' },
      
      { field: 'cpdHour', header: 'CPD Hours', type: 'text' }

    ];
    this.exportColumns = [
      { field: 'operativeFirstName', header: 'Operative First Name' },
      { field: 'operativeLastName', header: 'Operative Last Name' },
      { field: 'achievedOn', header: 'Achieved On' },
      { field: 'validTo', header: 'Valid To' },
      { field: 'trainingTypeName', header: 'Training Course' },
      { field: 'trainingExtraDescription', header: 'Description' },
      { field: 'categoryName', header: 'Category Name', type: 'text' },
      { field: 'totalObservations', header: 'Observations' },
       
      { field: 'cpdHour', header: 'CPD Hours' }
    ];

    this.rowMenuItems = [
      {
        label: 'Remove',
        icon: 'fas fa-trash-alt',
        visible: this.allowedOperations?.canDelete,
        styleClass: 'eca-menu-item-red',
        command: ($event) => this.confirmDeleteTrainingRecord($event)
      }
    ]

    this.matrixColumns = [
      { field: 'operativeName', header: 'Operative Name' },
      { field: 'businessUnit', header: 'Business Unit' },
      { field: 'operativeType', header: 'Operative Type' },
      { field: 'jobTitle', header: 'Job Title' },
      { field: 'course_1', header: 'Course 1' },
      { field: 'course_2', header: 'Course 2' },
      { field: 'course_3', header: 'Course 3' },
      { field: 'course_4', header: 'Course 4' },
      { field: 'course_5', header: 'Course 5' },
      { field: 'course_6', header: 'Course 6' },
      { field: 'course_7', header: 'Course 7' },
      { field: 'course_8', header: 'Course 8' },
      { field: 'course_9', header: 'Course 9' },
      { field: 'course_10', header: 'Course 10' },
      { field: 'course_11', header: 'Course 11' },
      { field: 'course_12', header: 'Course 12' },
      { field: 'course_13', header: 'Course 13' },
      { field: 'course_14', header: 'Course 14' },
      { field: 'course_15', header: 'Course 15' },
      { field: 'course_16', header: 'Course 16' },
      { field: 'course_17', header: 'Course 17' },
      { field: 'course_18', header: 'Course 18' },
      { field: 'course_19', header: 'Course 19' },
      { field: 'course_20', header: 'Course 20' },
      { field: 'course_21', header: 'Course 21' },
      { field: 'course_22', header: 'Course 22' },
      { field: 'course_23', header: 'Course 23' },
      { field: 'course_24', header: 'Course 24' },
      { field: 'course_25', header: 'Course 25' },
      { field: 'course_26', header: 'Course 26' },
      { field: 'course_27', header: 'Course 27' },
      { field: 'course_28', header: 'Course 28' },
      { field: 'course_29', header: 'Course 29' },
      { field: 'course_30', header: 'Course 30' },
      { field: 'course_31', header: 'Course 31' },
      { field: 'course_32', header: 'Course 32' },
      { field: 'course_33', header: 'Course 33' },
      { field: 'course_34', header: 'Course 34' },
      { field: 'course_35', header: 'Course 35' },
      { field: 'course_36', header: 'Course 36' },
      { field: 'course_37', header: 'Course 37' },
      { field: 'course_38', header: 'Course 38' },
      { field: 'course_39', header: 'Course 39' },
      { field: 'course_40', header: 'Course 40' },
      { field: 'course_41', header: 'Course 41' },
      { field: 'course_42', header: 'Course 42' },
      { field: 'course_43', header: 'Course 43' },
      { field: 'course_44', header: 'Course 44' },
      { field: 'course_45', header: 'Course 45' },
      { field: 'course_46', header: 'Course 46' },
      { field: 'course_47', header: 'Course 47' },
      { field: 'course_48', header: 'Course 48' },
      { field: 'course_49', header: 'Course 49' },
      { field: 'course_50', header: 'Course 50' },
      { field: 'course_51', header: 'Course 51' },
      { field: 'course_52', header: 'Course 52' },
      { field: 'course_53', header: 'Course 53' },
      { field: 'course_54', header: 'Course 54' },
      { field: 'course_55', header: 'Course 55' },
      { field: 'course_56', header: 'Course 56' },
      { field: 'course_57', header: 'Course 57' },
      { field: 'course_58', header: 'Course 58' },
      { field: 'course_59', header: 'Course 59' },
      { field: 'course_60', header: 'Course 60' },
      { field: 'course_61', header: 'Course 61' },
      { field: 'course_62', header: 'Course 62' },
      { field: 'course_63', header: 'Course 63' },
      { field: 'course_64', header: 'Course 64' },
      { field: 'course_65', header: 'Course 65' },
      { field: 'course_66', header: 'Course 66' },
      { field: 'course_67', header: 'Course 67' },
      { field: 'course_68', header: 'Course 68' },
      { field: 'course_69', header: 'Course 69' },
      { field: 'course_70', header: 'Course 70' },
      { field: 'course_71', header: 'Course 71' },
      { field: 'course_72', header: 'Course 72' },
      { field: 'course_73', header: 'Course 73' },
      { field: 'course_74', header: 'Course 74' },
      { field: 'course_75', header: 'Course 75' },
      { field: 'course_76', header: 'Course 76' },
      { field: 'course_77', header: 'Course 77' },
      { field: 'course_78', header: 'Course 78' },
      { field: 'course_79', header: 'Course 79' },
      { field: 'course_80', header: 'Course 80' },
      { field: 'course_81', header: 'Course 81' },
      { field: 'course_82', header: 'Course 82' },
      { field: 'course_83', header: 'Course 83' },
      { field: 'course_84', header: 'Course 84' },
      { field: 'course_85', header: 'Course 85' },
      { field: 'course_86', header: 'Course 86' },
      { field: 'course_87', header: 'Course 87' },
      { field: 'course_88', header: 'Course 88' },
      { field: 'course_89', header: 'Course 89' },
      { field: 'course_90', header: 'Course 90' },
      { field: 'course_91', header: 'Course 91' },
      { field: 'course_92', header: 'Course 92' },
      { field: 'course_93', header: 'Course 93' },
      { field: 'course_94', header: 'Course 94' },
      { field: 'course_95', header: 'Course 95' },
      { field: 'course_96', header: 'Course 96' },
      { field: 'course_97', header: 'Course 97' },
      { field: 'course_98', header: 'Course 98' },
      { field: 'course_99', header: 'Course 99' },
      { field: 'course_100', header: 'Course 100' },
     
    ];
  }

  viewTrainingRecord(trainingRecord: ITrainingRecord) {
    if (!trainingRecord?.id)
      return;

    this.router.navigate(["/training-record/" + trainingRecord.id]);
  }

  exportToExcel() {
    this.companyOperativesTraingRecordsToExport = [];
    this.trainingRecords.forEach(element => {
      let temporalDivElement = document.createElement("div");
      temporalDivElement.innerHTML = element.trainingExtraDescription;
      const tempObject = {
        operativeFirstName: element.operativeFirstName,
        operativeLastName: element.operativeLastName,
        achievedOn: this.datePipe.transform(element.achievedOn?.dateTime, 'dd/MM/yyyy'),
        validTo: this.datePipe.transform(element.validTo?.dateTime, 'dd/MM/yyyy'),
        trainingTypeName: element.trainingTypeName,
        trainingExtraDescription: temporalDivElement.textContent || temporalDivElement.innerText || "",
        categoryName: element.categoryName,
        totalObservations: element.totalObservations,
        //totalDocuments: element.totalDocuments,
        cpdHour: element.cpdHour
      };
      this.companyOperativesTraingRecordsToExport.push(tempObject);
    });

    this.exportExcelService.exportToExcel(this.companyOperativesTraingRecordsToExport, this.exportColumns, 'Company Operative Training Records')

  }

  exportTrainingMatrix() {
    //get data
    this.trainingRecordsService.getTrainingMatrixForCompany(this.companyId).subscribe(trainingMatrix => {
      //send for export
      this.exportExcelService.exportTrainingMatrix(trainingMatrix, this.matrixColumns, 'Company Operative Training Matrix')
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {

      });
    })
  };

  confirmDeleteTrainingRecord(trainingRecord: ITrainingRecordSummary) {
    this.confirmProcessService.openConfirmProcessModal('Are you sure you want to remove the training record for ' + trainingRecord.operativeName,
      "Remove training Record?", new EcaConfirmDeleteModalOptions()).subscribe({
        next: response => {
          if (response) {
            this.trainingRecordsService.deleteTrainingRecord(trainingRecord).subscribe(result => {
              if (result) {
                this.refreshListRequested.emit();
              }
            });
          }
        }
      });
  }
}
